import {useReportWidgetSeen} from '~/hooks/analytic-hooks'
import Header from './components/header/index.js'
import Deals from './components/sections/top-deals/index.js'
import Rank from './components/info-banners/rank-banner.js'
import TopDiscounted from './components/sections/top-discounted/index.js'
import ExploreLists from './components/sections/lists/explore-lists.js'
import Categories from './components/sections/lists/categories.js'
import DidYouKnow from './components/info-banners/did-you-know-banner.js'
import DealsLists from './components/sections/lists/deals-lists.js'
import BigSavings from './components/sections/sponsored/big-savings.js'
import SocialProof from './components/info-banners/social-proof-banner.js'
import {SponsoredDeals} from './components/sections/sponsored/sponsored-deals.js'
import RecommendedLists from './components/sections/lists/recommended-lists.js'

const NewHomepage = () => {
  const [homePageMainRef] = useReportWidgetSeen({
    widget_name: 'home-page-top-rated',
    widget_place: 'top',
  })

  return (
    <div className="w-full" ref={homePageMainRef}>
      <Header />
      <div className="my-7 flex flex-col gap-9">
        <Deals />
        <TopDiscounted />
        <Rank />
        <ExploreLists />
        <Categories from={0} to={4} />
        <DidYouKnow />
        <DealsLists />
        <BigSavings />
        <SocialProof />
        <Categories from={4} to={8} />
        <SponsoredDeals />
        <RecommendedLists />
        <Categories from={8} to={12} />
      </div>
    </div>
  )
}

export default NewHomepage
